import ReactHighlighter from 'react-syntax-highlighter';
import type { SyntaxHighlighterProps } from 'react-syntax-highlighter';
import { atomOneDark } from 'react-syntax-highlighter/dist/cjs/styles/hljs';
import CopyIconButton from '../copy-to-clipboard/copy-icon-button';

export const SyntaxHighlighter = ({
  showCopy = false,
  valueCopy,
  customStyle,
  ...props
}: SyntaxHighlighterProps) => {
  return (
    <div className="relative">
      {showCopy && (
        <div className="absolute right-2 top-2 cursor-pointer text-white">
          <CopyIconButton text={valueCopy ||props.children as string} />
        </div>
      )}
      <ReactHighlighter
        style={atomOneDark}
        customStyle={{
          padding: '8px 16px',
          borderRadius: '6px',
          ...customStyle,
        }}
        {...props}
      />
    </div>
  );
};

export default SyntaxHighlighter;
